import React from "react";
import { NavLink } from "react-router-dom";
import "../assets/styles/components/MenuRoutes.sass";

const MenuManizalesRoutes = () => (
  <div className="row MenuRoutes -manizales">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <ul className="MenuRoutes__list">
            <li className="MenuRoutes__list--item">
              <NavLink to="/manizales/carrera-manizales">CARRERA</NavLink>
            </li>
            <li className="MenuRoutes__list--item">
              <NavLink to="/manizales/travesia-bosque">TRAVESÍA</NavLink>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default MenuManizalesRoutes;
